var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        _vm._l(
          _vm.praticas.filter(function(pratica) {
            return pratica.ano
          }),
          function(pratica, index) {
            return _c(
              "el-collapse-item",
              {
                key: pratica.ano + "_" + index,
                attrs: { title: "Ano: " + pratica.ano }
              },
              [
                _c("div", [
                  _c("span", { staticClass: "title-praticas" }, [
                    _vm._v("Dados da prática")
                  ]),
                  _vm._v(" "),
                  _c("hr")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          attrs: { label: "Ano/Safra:", content: pratica.ano }
                        }),
                        _vm._v(" "),
                        _c("app-display", {
                          attrs: {
                            label: "Área (ha):",
                            content: pratica.areaDestinada
                          }
                        }),
                        _vm._v(" "),
                        _c("app-display", {
                          attrs: {
                            label: "Há rotação de culturas?",
                            content: pratica.hasRotacaoCulturas ? "Sim" : "Não"
                          }
                        }),
                        _vm._v(" "),
                        _c("app-display", {
                          attrs: {
                            label: "Cultura e produtividade:",
                            content: _vm.formataCulturasProdutividade(
                              pratica.atividadesAgricolaProdutividade
                            ),
                            isContentInNextLine: true
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          attrs: {
                            label: "Data de início da prática:",
                            content: _vm.formataDataInicio(pratica.dataInicio)
                          }
                        }),
                        _vm._v(" "),
                        _c("app-display", {
                          attrs: {
                            label: "Tipo de cobertura vegetal:",
                            content: _vm.formataTipoCoberturaVegetal(
                              pratica.coberturasVegetais
                            )
                          }
                        }),
                        _vm._v(" "),
                        pratica.coberturasVegetais.length &&
                        pratica.coberturasVegetais.includes("OUTRA")
                          ? _c("app-display", {
                              attrs: {
                                label: "Outro tipo de cobertura vegetal:",
                                content: pratica.outrosCoberturaVegetal
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("Bioinsumos", {
                  attrs: {
                    bioinsumo: {
                      utilizaBioinsumos: pratica.utilizaBioinsumos,
                      bioinsumos: pratica.bioinsumos
                    }
                  }
                }),
                _vm._v(" "),
                _c("Irrigacao", {
                  attrs: {
                    irrigacao: Object.assign(
                      {},
                      { possuiIrrigacao: pratica.possuiIrrigacao },
                      pratica.irrigacao
                    )
                  }
                }),
                _vm._v(" "),
                _c("Financiamento", {
                  attrs: {
                    financiamento: {
                      financiamentos: pratica.financiamentos,
                      outroFinanciamento: pratica.outroFinanciamento
                    }
                  }
                }),
                _vm._v(" "),
                _c("Descricao", { attrs: { descricao: pratica.descricao } })
              ],
              1
            )
          }
        ),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-324c1fbd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-324c1fbd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/SPDH/SPDH.vue
// module id = null
// module chunks = 